import { useMemo } from 'react'
import BahiaSulPage from '@/LandingPage/bahiaLandingPage'
import KlingerPage from '@/LandingPage/klingerLangingPage'
import MDPage from '@/LandingPage/mdLangingPage'
import TrisolutionPage from '@/LandingPage/trisolutionLangingPage'
import { getCleanDomain } from '@/utils/getCleanDomain'
import DSPage from '@/LandingPage/dsLangingPage'
import LandingPageHome from '@/features/landing-page/lading-page-home'

export default function LandingPage() {
  const domain = getCleanDomain()

  const page = useMemo(() => {
    const pages: Record<string, JSX.Element> = {
      'trisolution.com.br': <TrisolutionPage />,
      'mdtributaria.com.br': <MDPage />,
      'grupobahiasul.com.br': <BahiaSulPage />,
      'dsconsultoriat.com.br': <DSPage />
    }
    return pages[domain] ?? <KlingerPage />
  }, [domain])

  const isLocal = window.location.hostname.includes('localhost')
  if (isLocal) {
    return <LandingPageHome />
  }

  return page
}
